module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="phx-selecteur-activite-item-text" title="">'+
((__t=(label ))==null?'':__t)+
'</span>\r\n<span class="phx-selecteur-activite-item-icon ui-icon ui-icon-close"></span>';
}
return __p;
};
